import * as React from "react";
import {
  Box,
  Grid,
  Link,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ImagesContext } from "../Context";

interface ModifiersProps {
  modifiers: { code: string }[];
  onChange: (index: number, value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  totalModifiers: number;
  claimStatus: string;
}

const Modifiers = ({
  modifiers,
  onChange,
  onAdd,
  onRemove,
  totalModifiers,
  claimStatus,
}: ModifiersProps) => {
  const images = React.useContext(ImagesContext);
  const chargeModifiers = modifiers?.length;

  return (
    <Box>
      <Box display="flex" alignItems="center" columnGap="5px">
        <Typography
          sx={{
            color: "#A29D9B",
            fontWeight: 700,
            fontSize: "12px",
            lineHeight: "26px",
          }}
        >
          CPT Modifiers
        </Typography>
        {totalModifiers < 6 &&
          chargeModifiers > 0 &&
          chargeModifiers < 4 &&
          claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <IconButton onClick={onAdd} size="small" sx={{ padding: "0px" }}>
              <img
                src={images.add_icon}
                alt="Add Modifier"
                className="action-icon-image"
                style={{ width: 12, height: 12 }}
              />
            </IconButton>
          )}
      </Box>
      {chargeModifiers === 0 ? (
        <>
          <p
            style={{
              color: "#707070",
              fontWeight: 400,
              fontSize: "10px",
              lineHeight: "14px",
              marginBlockStart: "0px",
              marginBlockEnd: "0px",
              marginBottom: "5px",
            }}
          >
            Sometimes a CPT code requires additional modifiers to clarify the
            rendered services. <b>This is uncommon.</b>
          </p>
          {totalModifiers < 6 &&
            claimStatus !== "submitted" &&
            claimStatus !== "pending_submission" && (
              <Link
                sx={{
                  fontSize: "10px",
                  lineHeight: "14px",
                  textDecoration: "underline",
                  color: "#3F51B5",
                }}
                onClick={() => {
                  onAdd();
                }}
              >
                I need to add modifiers
              </Link>
            )}
        </>
      ) : (
        <Grid container spacing={1}>
          {modifiers?.map((mod, i) => (
            <Grid item xs={6} key={`modifier-${i + 1}`}>
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  backgroundColor: "#e5e0de",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    fontWeight: 500,
                    color: "#707070",
                  }}
                >
                  {i + 1}.
                </Typography>
                <Box className="field-container" sx={{ marginLeft: "0px" }}>
                  <TextField
                    size="small"
                    value={mod.code}
                    className="the-field"
                    required
                    variant="outlined"
                    placeholder="XX"
                    disabled={
                      claimStatus === "submitted" ||
                      claimStatus === "pending_submission"
                    }
                    onChange={(e) => onChange(i, e.target.value)}
                    sx={{
                      width: "100% !important",
                    }}
                    InputProps={{
                      sx: {
                        "& input": {
                          paddingRight: "3px !important",
                          paddingLeft: "3px !important",
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#707070",
                        },
                      },
                    }}
                    slotProps={{
                      htmlInput: {
                        maxLength: 2,
                      },
                    }}
                  />
                </Box>
                <IconButton
                  onClick={() => onRemove(i)}
                  size="small"
                  sx={{
                    padding: "0px",
                    height: "7px",
                    width: "7px",
                  }}
                >
                  <CloseIcon
                    fontSize="inherit"
                    sx={{ height: "12px", width: "12px" }}
                  />
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default Modifiers;
